import Typography from 'typography';
import deYoungTheme from 'typography-theme-de-young';

import { theme } from '../components/theme';

deYoungTheme.bodyColor = theme.textColor;

deYoungTheme.overrideThemeStyles = ({ rhythm }, options) => ({
  'h1,h2,h3,h4,h5,h6,p': {
    color: theme.textColor,
  },
});

const typography = new Typography(deYoungTheme);

export default typography;



// WEBPACK FOOTER //
// ./src/utils/typography.js